/* RESPONSIBLE TEAM: team-proactive-support */
import RulesetLinkSerializer from 'embercom/serializers/matching-system/ruleset-link';
export default RulesetLinkSerializer;
